// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"0899a221","566":"7551c26f","837":"ec837e8d"}[chunkId] + ".chunk.js";
};